// Copyright 2025. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { connect } from 'react-redux';
import {
    ProgressStep,
    Translate,
} from '@plesk/ui-library';
import { Dialog } from 'common/components/Dialog/Dialog';
import { ICONS } from 'common/constants';
import {
    DisasterRecoveryEntityStatus,
    IDisasterRecoveryEntityResponse,
} from 'common/api/resources/DisasterRecovery';

interface IDisasterRecoveryEntityStatusDialogProps {
    entity: IDisasterRecoveryEntityResponse;
    isOpen: boolean;
    handleClose: () => void;
}

export type DisasterRecoveryEntityStatusDialogProps =
    IDisasterRecoveryEntityStatusDialogProps;

const transformTaskStatusToProgressStatus = function (status: DisasterRecoveryEntityStatus) {
    if (status === DisasterRecoveryEntityStatus.FAILED) {
        return 'error';
    }

    if (status === DisasterRecoveryEntityStatus.PENDING) {
        return 'not_started';
    }

    if (status === DisasterRecoveryEntityStatus.COMPLETED) {
        return 'done';
    }

    return status;
};

export const DisasterRecoveryEntityStatusDialog: React.FC<DisasterRecoveryEntityStatusDialogProps> = ({
    entity,
    isOpen,
    handleClose,
}) => {
    const renderStep = () => {
        const status = transformTaskStatusToProgressStatus(entity.status);
        let statusMessage = null;
        if (entity.task && entity.task.output.length > 0) {
            statusMessage = entity.task.output;
        } else if (entity.status === DisasterRecoveryEntityStatus.FAILED) {
            statusMessage = entity.fail_reason;
        }

        return (
            <ProgressStep
                icon={ICONS.GEAR}
                status={status}
                progress={entity.task ? entity.task.progress : 0}
            >
                {statusMessage}
            </ProgressStep>
        );
    };

    return (
        <Dialog
            heading={entity.target_compute_resource
                ? <Translate
                    content="disasterRecovery.history.entities.list.statusDialog.titleWithTargetCr"
                    params={{ vmName: entity.compute_resource_vm.name, targetCrName: entity.target_compute_resource.name }} />
                : <Translate
                    content="disasterRecovery.history.entities.list.statusDialog.titleWithoutTargetCr"
                    params={{ vmName: entity.compute_resource_vm.name }} />

            }
            closeHandler={handleClose}
            isOpen={isOpen}
            size="xs"
        >
            {renderStep()}
        </Dialog>
    );
};

export default connect(null, null)(DisasterRecoveryEntityStatusDialog);
